/* eslint-disable max-classes-per-file */
import { Languages } from '@merchant-portal/mp-models'

export const Countries = {
  SE: 'SE',
  DK: 'DK',
  NO: 'NO',
  FI: 'FI',
}

export const getCountryIds = () => {
  const countryIds = []
  Object.keys(Countries).forEach(countryId => {
    countryIds.push(Countries[countryId])
    return null
  })
  return countryIds
}

export class CurrencySymbol {
  constructor({ prefix = '', suffix = '' }) {
    this.prefix = prefix
    this.suffix = suffix
  }

  wrap(value) {
    return [this.prefix, value, this.suffix].filter(v => !!v).join(' ')
  }

  wrapRange(from, to) {
    return this.wrap(`${from}–${to}`)
  }

  toString() {
    return this.prefix || this.suffix
  }
}

export const getCurrencySymbol = country => {
  switch (country) {
    case Countries.FI:
      return new CurrencySymbol({ suffix: '€' })
    case Countries.DK:
      return new CurrencySymbol({ suffix: 'kr.' })
    case Countries.SE:
    case Countries.NO:
    default:
      return new CurrencySymbol({ suffix: 'kr' })
  }
}

export const getDefaultVatRate = country => {
  switch (country) {
    case Countries.FI:
      return 0.24
    case Countries.SE:
    case Countries.DK:
    case Countries.NO:
    default:
      return 0.25
  }
}

export const getEIDProviderName = country => {
  switch (country) {
    case Countries.FI:
      return 'Sähköinen allekirjoitus'
    case Countries.DK:
      return 'MitID'
    case Countries.SE:
      return 'BankID'
    case Countries.NO:
      return 'BankID'
    default:
      return 'BankID'
  }
}

export const isEIDLinkRequired = country => {
  switch (country) {
    case Countries.FI:
    case Countries.DK:
      return true
    case Countries.SE:
    case Countries.NO:
    default:
      return false
  }
}

export const getCountryFromLanguage = language => {
  switch (language) {
    case Languages.NORWEGIAN:
      return Countries.NO
    case Languages.DANISH:
      return Countries.DK
    case Languages.FINNISH:
      return Countries.FI
    case Languages.SWEDISH:
    default:
      return Countries.SE
  }
}
